import { Button, Grid, Input } from '@scuf/common';
import useFetch from 'helpers/hooks/useFetch';
import { RmaModelLiteMf} from 'models';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { RMAMANUFATURA, user, notificationAtom } from 'resources';
import { RmaLiteMf } from 'resources/atoms/rmaManufaturaAtom';
import useUser from 'helpers/hooks/useUser';

function AdmWorkOrdersAccordion(): JSX.Element {
    const [orderData, setorderData] = useRecoilState(RmaLiteMf);
    const [change, setChange] = useState<boolean>(false);
    const [number, setNumber] = useState(orderData?.numberPV);
    const [numberQuotation, setNumberQuotation] = useState(orderData?.numberQuotation);
    const { t } = useTranslation(['spareparts', 'common']);
    const [, editPVManufacturing, loading] = useFetch<RmaModelLiteMf>({ url: RMAMANUFATURA.editPVManufacturing, method: 'POST' });
    const { user: userDetails } = useUser();
    const setNotification = useSetRecoilState(notificationAtom);

    const handleSave = async (): Promise<void> => {
        try{
            await editPVManufacturing({ ...orderData, numberPV: number, numberQuotation: numberQuotation}, current =>
                setorderData(old => ({ ...old, numberPV: current.data.numberPV, numberQuotation: current.data.numberQuotation }))
            );
            setNotification((old: any) => ({ ...old, message: t('common:translation.ChangeSuccess'), type: 'success' }));
            setChange(false);
            window.location.reload();
        }catch{
            setNotification((old: any) => ({ ...old, message: t('common:translation.ChangeError'), type: 'error' }));
        }
    };

    return (
        <>
            <Grid>
                <Grid.Column className="grid-with-gap">
                    <Input
                        value={number}
                        label={t('common:translation.ChangePV')}
                        onChange={value => {
                            setChange(value !== '' ? true : false);
                            setNumber(value);
                        }}
                    ></Input>
                        <Input
                            value={numberQuotation}
                            label={t('common:translation.ChangeQuotation')}
                            onChange={value => {
                                setChange(true);
                                setNumberQuotation(value !== '' ? value : '');
                            }}
                        ></Input>
                </Grid.Column>
            </Grid>
            <div className="buttonsSearch">
                <Button
                    content={t('common:actions.Cancel')}
                    type="secondary"
                    disabled={!change}
                    onClick={() => {
                        setChange(false);
                        setNumber(orderData?.numberPV);
                        setNumberQuotation(orderData?.numberQuotation);
                    }}
                ></Button>
                <Button disabled={!change} content={t('common:actions.Save')} loading={loading} onClick={handleSave}></Button>
            </div>
        </>
    );
}

export default AdmWorkOrdersAccordion;